// extracted by mini-css-extract-plugin
module.exports = {"socials":"socials_socials__TVW7C","icon":"socials_icon__BKWcX"};